import { render, staticRenderFns } from "./generalManagement.vue?vue&type=template&id=b8809634"
import script from "./generalManagement.vue?vue&type=script&lang=js"
export * from "./generalManagement.vue?vue&type=script&lang=js"
import style0 from "./generalManagement.vue?vue&type=style&index=0&id=b8809634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports